export default __webpack_public_path__ + "static/media/CS-Logo-white.dc103c2c.png";